import { Navigate, useOutletContext } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import type { RouteContextParams } from 'modules/timeoff/lib/routeContextParams'

const RedirectToPolicyDetails = () => {
  const { navigation } = useNavigation()

  const { policy } = useOutletContext<RouteContextParams>()

  // If policy is not found or ID is invalid, redirect to the policies tab
  if (!policy?.attributes?.id) {
    const to = navigation.settings.timeoffPolicies.policies.fullPath()
    return <Navigate to={to} />
  }

  const to = navigation.settings.timeoffPolicies.id.details.fullPath({ id: policy.attributes.id })

  return <Navigate to={to} />
}

export default RedirectToPolicyDetails
